import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Translator } from 'ggApp/modules/translator';

import { SEARCH_OVERLAY_ACTION } from 'ggApp/modules/gaAnalytics/constants';
import { Wrap, Line, ProductSection, Product } from './styles';

const getTk = (withSearchedProducts, totalItems) => {
    if (withSearchedProducts) {
        return totalItems === 1 ? 'SEARCHBAR_RESULTS_QTY_SHORT' : 'SEARCHBAR_RESULTS_QTY';
    }
    return 'SEARCHBAR_TRENDING_PRODUCTS';
};

const Products = ({
    className,
    products,
    totalItems,
    withSearchedProducts,
    handleClick,
    registerSearchOverlayEvent,
}) => {
    const handleClickWithGtmEvent = useCallback(
        (product) => () => {
            const { name, sku } = product || {};
            registerSearchOverlayEvent(SEARCH_OVERLAY_ACTION.productClick, { name, sku });
            handleClick();
        },
        [registerSearchOverlayEvent, handleClick],
    );
    return (
        <Wrap className={className}>
            <Line
                title={
                    <Translator
                        tk={getTk(totalItems, withSearchedProducts)}
                        withValues={{ totalItems }}
                    />
                }
            />
            <ProductSection>
                {products.map((product) => (
                    <Product
                        handleClick={handleClickWithGtmEvent(product)}
                        key={product.id}
                        product={product}
                        cardType="horizontal"
                    />
                ))}
            </ProductSection>
        </Wrap>
    );
};

Products.propTypes = {
    className: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.object),
    withSearchedProducts: PropTypes.bool,
    handleClick: PropTypes.func,
    totalItems: PropTypes.number,
    registerSearchOverlayEvent: PropTypes.func,
};

Products.defaultProps = {
    className: '',
    products: [],
    withSearchedProducts: false,
    handleClick: () => {},
    totalItems: null,
    registerSearchOverlayEvent: () => {},
};

export default Products;
